<template>
  <form
    class="d-flex-column justify-center align-start gap-18"
    @submit.prevent="doLogin(getParams)"
  >
    <div class="d-flex-row height-max-content">
      <p
        class="regular-m f-w-400 font-family-2 t-grey-dark"
        style="text-align: center"
      >
        {{ $t("code_sent_1") }}<br /><span class="t-white bold-l">{{
          email
        }}</span>
      </p>
    </div>
    <div class="d-flex-column">
      <div class="d-flex-row gap-5" ref="otpCont">
        <input
          type="text"
          class="otp-input"
          :maxlength="1"
          v-for="(digit, ind) in digitCount"
          :key="digit"
          :value="digits[ind]"
          @paste="pasteCode"
          @keydown="($event) => handleKeyDown($event, ind)"
          @input="($event) => handleInput($event, ind)"
          inputmode="numeric"
          pattern="[0-9]*"
        />
      </div>
      <div class="d-flex-row space-between">
        <button
          class="flex-2 dark opacity b-radius-6 xl font-family-1 body-m f-w-600 height-48"
          type="button"
          @click.stop="goBack"
        >
          {{ $t("dashboard.payout_details.cancel") }}
        </button>
        <button
          class="flex-8 primary filled b-radius-6 xl font-family-1 body-l f-w-600 height-48"
          ref="submit-code"
          type="submit"
          :class="[isLoading ? 'loading' : '']"
        >
          {{ $t("login.verify") }}
        </button>
      </div>
    </div>
  </form>

  <form
    class="d-flex-row gap-5"
    @submit.prevent="handleResend"
    style="margin-top: 24px"
  >
    <p class="regular-m font-family-2 t-grey">
      {{ $t("did_not_receive") }}
    </p>
    <button
      class="regular-m font-family-2 gap-2"
      :disabled="isWaiting"
      :class="[isWaiting ? 't-grey' : 't-orange']"
    >
      {{ $t("resend_otp")
      }}<span v-if="resetDelay > 0">{{ $t("in") }}{{ resetDelay }}s</span>
    </button>
  </form>
</template>
<script>
import VOtpInput from "vue3-otp-input";

export default {
  data() {
    return {
      digitCount: 4,
      digits: [],
      isLoading: false,
      resetTimeout: null,
      resetDelay: 0,
      otpValue: "",
    };
  },
  components: {
    VOtpInput,
  },
  props: {
    email: {
      default: "",
    },
    doLogin: {
      default: Function,
    },
    captchaToken: {
      default: "",
    },
    goBack: {
      default: () => {},
    },
    isLoading: {
      default: false,
    },
  },
  emits: ["doCancel"],
  methods: {
    handleOtp(event, index) {
      if (
        event.key === "Meta" ||
        event.key === "v" ||
        event.key === "Control"
      ) {
        return;
      }
      if (
        event.key != "Tab" &&
        event.key != "ArrowRight" &&
        event.key != "ArrowLeft"
      ) {
        // event.preventDefault();
      }
      if (event.key == "Backspace") {
        if (index != 0 && !this.digits[index]) {
          this.$refs.otpCont.children[index - 1].focus();
          return;
        }
        return;
      }
      console.log("EVENT VALUE", event.target.value);
      if (new RegExp("^([0-9])$").test(event.target.value)) {
        this.digits[index] = event.target.value;
        if (index != this.digitCount - 1) {
          this.$refs.otpCont.children[index + 1].focus();
        }
      }
    },

    handleKeyDown(event, index) {
      if (
        event.key === "Meta" ||
        event.key === "v" ||
        event.key === "Control"
      ) {
        return;
      }

      if (event.key === "Backspace") {
        if (index != 0 && !this.digits[index]) {
          this.$refs.otpCont.children[index - 1].focus();
          return;
        }
        this.digits[index] = null;
        return;
      }
    },

    handleInput(event, index) {
      const value = event.target.value;
      if (new RegExp("^([0-9])$").test(value)) {
        this.digits[index] = value;
        if (index !== this.digitCount - 1) {
          this.$refs.otpCont.children[index + 1].focus();
        }
      } else {
        event.target.value = ""; // Clear invalid input
        this.digits[index] = null;
      }
    },

    handleCancel(step) {
      this.$emit("doCancel", { step: step });
    },

    clear() {
      this.digits = [];
    },

    submit($event) {
      this.isLoading = true;
    },

    handleResend($event) {
      this.setResendTimeout();
      this.doLogin(this.getParamsResend);
      // this.submitForm($event, this.getParamsResend);
    },

    async pasteCode(e) {
      // Get pasted data via clipboard API
      let copiedText = e.clipboardData.getData("text");
      if (!isNaN(parseInt(copiedText))) {
        this.digits = [...copiedText];
        copiedText = Array.from(String(copiedText), Number);
        for (let i = 0; i < copiedText.length; i++) {
          this.digits[i] = copiedText[i];
        }
      }
    },

    setResendTimeout() {
      this.resetDelay = 30;
    },
  },

  computed: {
    isWaiting() {
      if (this.resetDelay > 0) return true;
      return false;
    },
    getToken() {
      // return this.otpValue;
      let token = "";
      for (let i = 0; i < this.digitCount; i++) {
        token += this.digits[i];
      }
      return token;
    },

    getParams() {
      return {
        step: 1,
        email: this.email,
        token: this.getToken,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        dicordCode: this.code,
      };
    },
    getParamsResend() {
      return {
        email: this.email,
        step: 4,
        token: "",
      };
    },
  },

  watch: {
    getParams() {
      if (this.getToken !== null && this.getToken.length === 4) {
        this.$refs["submit-code"].click();
      }
    },
    resetDelay() {
      if (this.resetDelay === 30) {
        if (!this.resetTimeout) {
          this.resetTimeout = setInterval(() => {
            this.resetDelay = this.resetDelay - 1;
          }, 1000);
        }
      } else if (this.resetDelay === 0) {
        this.resetTimeout = clearInterval(this.resetTimeout);
      }
    },
    // digits() {
    //   if (this.digits.length === this.digitCount) {
    //     this.doLogin(this.getParams);
    //   }
    // },
  },
  beforeMount() {
    this.setResendTimeout();
  },
  beforeUnmount() {
    if (this.resetTimeout) {
      this.resetTimeout = clearInterval(this.resetTimeout);
    }
  },
};
</script>
